<syn-page-loader [class.auth-loading]="loading" [loading]="loading"></syn-page-loader>

<div fxLayout="row" fxLayoutAlign="center start">
    <div fxLayout="column" fxFlex="65" class="authorizationsForm">
        <div *ngIf="isInternal" fxLayout="row" fxLayoutAlign="space-between center" class="starRightsForm">
            <mat-slide-toggle color="primary" [(ngModel)]="starProjectMode">Donner des rôles sur tous les projets</mat-slide-toggle>

            <mat-form-field fxFlex="50" *ngIf="starProjectMode" appearance="outline">
                <mat-select [formControl]="starProjectRoles"
                            placeholder="Choisissez des rôles"
                            multiple>
                  <mat-option *ngFor="let role of roles"
                              [value]="role.id">
                    <syn-select-option-role [role]="role"></syn-select-option-role>
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="column" *ngIf="!starProjectMode" fxFlex>
            <h4 class="syn-subtitle" fxFlexOffset="3">Attribution par société</h4>
            <mat-divider></mat-divider>

            <div fxLayout="row">
                <syn-picker [formControl]="company"
                    placeholder="Trouver une société"
                    [contentLoader]="companyPickerContentLoader"
                    [content]="pickerCompanies$"
                    [itemTemplate]="companyItemTemplate"
                    [strictSearch]="false"
                    toolTip=""
                    fxFlex="50">
                </syn-picker>

                <ng-template #companyItemTemplate
                            let-name="content.name"
                            let-source="content.source"
                            let-id="content.id">
                    <div fxLayout="row"
                        fxLayoutAlign="space-between center"
                        [matTooltip]="id">
                        <span class="template_header">{{ name }}</span>
                        <span class="template_subheading">
                            <syn-source class="syn-source__small" [source]="source"></syn-source>
                        </span>
                    </div>
                </ng-template>
            </div>

            <ng-template #noTabs>
                <syn-message-box leftIcon="information-outline"
                                color="info"
                                class="info-box">
                    Aucun rôle n'est attribué (vous pouvez <strong>trouver une société</strong> afin d'assigner des rôles à ses projets).
                </syn-message-box>
            </ng-template>

            <div fxLayout="column" *ngIf="tabs?.length;else noTabs">

                <mat-tab-group [selectedIndex]="selectedTab.value">
                    <mat-tab *ngFor="let tab of tabs; let index = index">
                        <ng-template mat-tab-label>
                            {{ tab.company.name }}
                            <button mat-icon-button
                                    (click)="removeTab(index)" [style.padding]="'0px 3px 0px 0px'" [style.margin-left]="'0.3em'">
                                <mat-icon svgIcon="close"></mat-icon>
                            </button>
                        </ng-template>

                        <div fxLayout="row">
                            <syn-projects-roles-table
                                [projects]="tab.projects"
                                [roles]="roles"
                                [initialSelection]="initialAuthorizations"
                                [multiple]="isInternal"
                                fxFlexFill>
                            </syn-projects-roles-table>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>

    <div fxLayout="column" fxLayoutAlign="space-evenly start" fxFlex="25" fxFlexOffset="5">
        <mat-card appearance="outlined" class="syn-card syn--about-card">
            <mat-card-title-group class="syn-text--info">
                <mat-card-title class="syn--about">A propos...</mat-card-title>


                <mat-icon class="dp48" mat-card-avatar svgIcon="information-outline"></mat-icon>
            </mat-card-title-group>

            <mat-card-content>
                <mat-card-subtitle class="mat-subhead">Trouver une société ?</mat-card-subtitle>

                <p>
                    L'attribution des rôles pour un bot interne inclut la possibilité de choisir ses droits sur les projets d'une ou plusieurs sociétés.
                </p>

                <mat-card-subtitle class="mat-subhead">Sur tous les projets ?</mat-card-subtitle>
                <p>
                    Il est possible d'attribuer une même liste de rôles sur la totalité des projets.
                </p>

            </mat-card-content>
        </mat-card>
    </div>
</div>
